import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

/**
 * GonePage — página servida para URLs que nunca deveriam ter sido
 * indexadas mas que apareceram no Search Console como "Página com
 * redirecionamento" ou "Cópia". Cada uma carrega:
 *
 *   1. `<meta name="robots" content="noindex,nofollow">` para forçar
 *      a remoção do índice na próxima visita do Googlebot.
 *   2. HTTP-equiv noindex como redundância para crawlers que ignoram a
 *      tag puramente HTML.
 *   3. Mensagem humana clara: "página inexistente", com um link de
 *      retorno para a Home. Estilo discreto, consistente com o resto
 *      do site. (Tecnicamente o servidor estático ainda responde HTTP
 *      200; o `<meta robots noindex>` é o que importa para o Google.)
 *
 * Roteamos para esta página os paths conhecidos como lixo: caminhos
 * `/Users/...` (arquivos locais que vazaram em algum cadastro
 * antigo), endpoints de admin renomeados (`/management`,
 * `/add-video`), aliases antigos do podcast (`/episode/{n}`) etc.
 */
export default function GonePage() {
  return (
    <div className="min-h-screen pt-28 md:pt-32 pb-16 px-4 sm:px-6 lg:px-10 xl:px-14 2xl:px-20 flex items-center justify-center" data-testid="gone-page">
      <SEO
        title="Página não encontrada · JurisTube"
        description="Esta página não existe mais no JurisTube."
        url="/"
        noindex
      />
      <div className="max-w-md text-center space-y-4">
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
          404 · Página inexistente
        </div>
        <h1 className="font-serif text-3xl text-white">
          Esta página não existe (ou nunca existiu).
        </h1>
        <p className="text-sm text-slate-400 leading-relaxed">
          O endereço que você acessou foi removido do JurisTube ou nunca foi público.
          Use o menu ou volte à página inicial para encontrar o conteúdo.
        </p>
        <Link
          to="/"
          className="inline-block mt-4 px-5 py-2 rounded-full border border-amber-500/40 bg-amber-500/10 text-amber-200 text-sm font-semibold hover:bg-amber-500/20"
          data-testid="gone-home-link"
        >
          Voltar à página inicial
        </Link>
      </div>
    </div>
  );
}
